// import axios from "axios";
import axios from 'axios';
import * as React from 'react';
import SunEditor, { buttonList } from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import TextEditorView from './TextEditor';

const SunEditorView: React.FC<any> = ({ defaultValue, onChange, disable, small }) => {
    const editor: any = React.useRef(null);
    const [isEditorFocused, setIsEditorFocused] = React.useState(false);

    const handleFocus = () => {
        setIsEditorFocused(true);
    };

    const handleBlur = () => {
        setIsEditorFocused(false);
    };

    const getSunEditorInstance = (sunEditor) => {
        editor.current = sunEditor;
    };

    const uploadFiles = async (file) => {
        const formData = new FormData();
        file.forEach(element => {
            formData.append('file', element, 'file.png');
        });
        const axiosData = await axios.post(`${process.env.API_URL}/upload/add`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        return { success: true, fileUrl: axiosData.data.files[0] };
    };

    function dataURLtoBlob(dataURL) {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    }

    const handleImageUpload = async (targetImgElement, index, state, imageInfo, remainingFilesCount) => {
        console.log(targetImgElement, index, state, imageInfo, remainingFilesCount, imageInfo.src);
        const data = await uploadFiles([dataURLtoBlob(imageInfo.src)]);
        targetImgElement.src = `${process.env.FILE_URL + data.fileUrl}`;

    };

    const _buttons = [
        ['undo', 'redo'],
        ['font', 'fontSize', 'formatBlock'],
        ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
        ['fontColor', 'hiliteColor'],
        ['outdent', 'indent'],
        ['align', 'horizontalRule', 'list', 'table'],
        ['fullScreen', 'codeView']
    ];

    return (
        <>
            <div
                onMouseEnter={() => handleFocus()}
                onMouseLeave={() => handleBlur()}
            >
                <TextEditorView
                    lang={'en'}
                    // height="100"
                    placeholder="Please type here..."
                    defaultValue={defaultValue}
                    disableToolbar={disable}
                    disable={disable}
                    hideToolbar={disable || !isEditorFocused}
                    getSunEditorInstance={getSunEditorInstance}
                    onImageUpload={handleImageUpload}
                    setOptions={{
                        // height: '300%',
                        buttonList: small ? _buttons : [...buttonList.complex, ['lineHeight']],
                        fontSizeUnit: 'px',
                        charCounter: false,
                    }}
                    // onFocus={handleFocus}
                    // onBlur={handleBlur}
                    onChange={(e) => onChange(e)}
                />
            </div>
        </>
    );
};

export default SunEditorView;
